import symbology from '../Assets/default_habitat_symbology.json';

type SymbologyEntry = {
  Colour?: string;
  Hatch?: string;
  Marker?: string;
  Size?: number;
};

type SymbologySection = Record<string, SymbologyEntry>;

const buildColorLookup = (raw: unknown) => {
  const colorByKey = new Map<string, string>();
  const colorByKeyLower = new Map<string, string>();

  if (!raw || typeof raw !== 'object') {
    return { colorByKey, colorByKeyLower };
  }

  Object.values(raw as Record<string, SymbologySection>).forEach((section) => {
    if (!section || typeof section !== 'object') return;
    Object.entries(section).forEach(([key, entry]) => {
      if (!entry?.Colour) return;
      if (!colorByKey.has(key)) {
        colorByKey.set(key, entry.Colour);
      }
      const lowerKey = key.toLowerCase();
      if (!colorByKeyLower.has(lowerKey)) {
        colorByKeyLower.set(lowerKey, entry.Colour);
      }
    });
  });

  return { colorByKey, colorByKeyLower };
};

const defaultLookup = buildColorLookup(symbology as Record<string, SymbologySection>);

export const getSymbologyColor = (key?: string | null): string | undefined => {
  if (!key) return undefined;
  const trimmed = key.trim();
  return defaultLookup.colorByKey.get(trimmed) ?? defaultLookup.colorByKeyLower.get(trimmed.toLowerCase());
};

export const createSymbologyColorLookup = (raw: unknown) => {
  const lookup = buildColorLookup(raw);
  return (key?: string | null): string | undefined => {
    if (!key) return undefined;
    const trimmed = key.trim();
    return lookup.colorByKey.get(trimmed) ?? lookup.colorByKeyLower.get(trimmed.toLowerCase());
  };
};
